import { defineStyleConfig } from '@chakra-ui/react';

import { ButtonLikePattern } from '../patterns';

// Exports
export const Button = defineStyleConfig({
  baseStyle: {
    ...ButtonLikePattern.baseStyles.static,
    ...ButtonLikePattern.baseStyles.interactive,
  },

  sizes: {
    sm: {
      ...ButtonLikePattern.sizes.layout.sm,
      ...ButtonLikePattern.sizes.fixedHeight.sm,
      paddingBlock: 0,
    },
    md: {
      ...ButtonLikePattern.sizes.layout.md,
      ...ButtonLikePattern.sizes.fixedHeight.md,
      paddingBlock: 0,
    },
    lg: {
      ...ButtonLikePattern.sizes.layout.lg,
      ...ButtonLikePattern.sizes.fixedHeight.lg,
      paddingBlock: 0,
    },
  },

  variants: {
    primary: (props) => ({
      ...ButtonLikePattern.variants.solid.static(props),
      ...ButtonLikePattern.variants.solid.interactive(props),
    }),

    'primary-muted': (props) => ({
      ...ButtonLikePattern.variants['solid-muted'].static(props),
      ...ButtonLikePattern.variants['solid-muted'].interactive(props),
    }),

    secondary: (props) => ({
      ...ButtonLikePattern.variants.outline.static(props),
      ...ButtonLikePattern.variants.outline.interactive(props),
    }),

    'secondary-muted': (props) => ({
      ...ButtonLikePattern.variants['outline-muted'].static(props),
      ...ButtonLikePattern.variants['outline-muted'].interactive(props),
    }),

    'v2-ghost': (props) => ({
      ...ButtonLikePattern.variants.ghost.static(props),
      ...ButtonLikePattern.variants.ghost.interactive(props),
    }),

    link: ButtonLikePattern.variants.link.interactive,
  },
});

export type ButtonVariant = keyof NonNullable<typeof Button['variants']>;
